// import tailwindcss config
import resolveConfig from "tailwindcss/resolveConfig"
import tailwindConfig from "@/../tailwind.config"

// export full tailwindcss config
export const fullTailwindcssConfig = resolveConfig(tailwindConfig)

// get screen size bu name
export function getScreenSizeByName(sizeName) {
  return fullTailwindcssConfig.theme.screens[sizeName].replace("px", "")
}

// set required word if it on the rules
export function inputRequireSuffix(rules) {
  return rules && rules.split("|").includes("required") ? "*" : ""
}

// set color based on status code
export function setColorByStatus(status) {
  if ([200, 201].includes(status)) {
    return "bg-green-500"
  } else if ([404, 401].includes(status)) {
    return "bg-yellow-500"
  } else if (status === 500) {
    return "bg-red-500"
  } else {
    return "bg-blue-500"
  }
}

// set color based on status code
export function setColorByStatusText(status, bg = true) {
  if (["approved"].includes(status)) {
    return bg ? "bg-green-500" : "text-green-500"
  } else if (["pending"].includes(status)) {
    return bg ? "bg-yellow-500" : "text-yellow-500"
  } else if (["rejected"].includes(status)) {
    return bg ? "bg-red-500" : "text-red-500"
  } else {
    return bg ? "bg-red-500" : "text-red-500"
  }
}

// API routes
export const API_ROUTE = "https://jobs.argons.io/api/"
